import { CartPage } from '@/@types/content';
import { OrderLineViewModel } from '@/@types/client-api';
import { Variant } from '@/redux/slices/pdpSlice';
import { isSTSVariant } from '../PDP/helpers';
import { PublicationEcomLabels } from '../PDP/labels';

export const getCartProductDisplayType = (item: OrderLineViewModel) => {
  const categories = item.itemDataViewModel?.categories ?? [];
  const publicationType = categories[1];
  const itemClassSk = categories[3];
  const isCourseHandbookStp = publicationType === 'Course Handbook' && itemClassSk === '257';
  const isAnswerBookStp = itemClassSk === '168' && item?.isUpkeepItem === false;

  return isCourseHandbookStp || isAnswerBookStp ? PublicationEcomLabels.stp : item.displayType;
};

export const shouldLookupTreatiseStpLabel = (item: OrderLineViewModel) => {
  const itemClassSk = item.itemDataViewModel?.categories?.[3];

  return itemClassSk === '111' && item.isUpkeepItem === false;
};

export const getTreatiseCartProductDisplayType = (
  item: OrderLineViewModel,
  variants: Variant[],
  expiredPrintVariants: Variant[],
  fallbackDisplayType?: string | null
) => {
  const isCurrentStsVariant = variants.some(
    variant => variant.code === item.code && variant.format === 'sts'
  );
  const includeSubscriptionLabel =
    isSTSVariant([...variants, ...expiredPrintVariants]) && expiredPrintVariants.length === 0;

  return isCurrentStsVariant && !includeSubscriptionLabel
    ? PublicationEcomLabels.stp
    : fallbackDisplayType;
};

export const MyCartLabels = (cartPageData?: CartPage) => {
  return {
    outOfStockText:
      cartPageData?.outOfStockText ||
      'This item is temporarily out of stock. You can still place your order, and we’ll ship it as soon as it becomes available.',
    preOrderText:
      cartPageData?.preOrderText ||
      'This is a pre-order item. Continue with your purchase and your item will be delivered when it becomes available.',
    invalidQuantityText: 'Please only use numbers.',
    POECLiveWebcastText:
      cartPageData?.['poecLiveWebcastText' as keyof CartPage] ||
      'Access to the online version of the Patent Office Exam Course Online included.'
  };
};
